import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function GuardAlert() {
  const [alert, setAlert] = useState(null);
  useEffect(() => {
    const on = (e) => setAlert(e.detail);
    window.addEventListener("koine-guard", on);
    return () => window.removeEventListener("koine-guard", on);
  }, []);
  return (
    <Dialog open={!!alert} onOpenChange={(o) => !o && setAlert(null)}>
      <DialogContent className="max-w-sm border-red-500/50" data-testid="guard-alert-dialog">
        <DialogHeader>
          <div className="mb-2 grid h-12 w-12 place-items-center rounded-2xl bg-red-500/15 text-red-400"><ShieldAlert size={24} /></div>
          <DialogTitle className="text-red-300">Envio bloqueado pelo Guarda-Costas IA</DialogTitle>
          <DialogDescription>Detectamos conteúdo impróprio. Nada foi publicado ou enviado.</DialogDescription>
        </DialogHeader>
        {alert && (
          <div className="space-y-2 rounded-xl bg-white/5 p-3 text-sm">
            {alert.field && <p data-testid="guard-alert-field"><span className="text-muted-foreground">Onde: </span>{alert.field}</p>}
            {alert.reason && <p data-testid="guard-alert-reason"><span className="text-muted-foreground">Motivo: </span>{alert.reason}</p>}
            {alert.blocked
              ? <p className="font-bold text-red-400" data-testid="guard-alert-blocked">Perfil bloqueado preventivamente por 24h.</p>
              : alert.strikes ? <p className="font-semibold text-amber-300" data-testid="guard-alert-strikes">Infração {alert.strikes}/3 registrada. Com 3 infrações o perfil é bloqueado.</p> : null}
          </div>
        )}
        <Button onClick={() => setAlert(null)} className="w-full rounded-full" data-testid="guard-alert-close">Entendi</Button>
      </DialogContent>
    </Dialog>
  );
}
